import { render, staticRenderFns } from "./Instructors.vue?vue&type=template&id=5ff720b6&scoped=true&lang=pug"
import script from "./Instructors.vue?vue&type=script&lang=js"
export * from "./Instructors.vue?vue&type=script&lang=js"
import style0 from "./Instructors.vue?vue&type=style&index=0&id=5ff720b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff720b6",
  null
  
)

export default component.exports